module.exports = __webpack_public_path__ + "static/28-img-1-b592a7280c9ecf0d7c703b0752917d76.png";